import { Url } from 'app/utils';
import { $Analytics, Application, $Constants, $CurrentUser, MessageBus } from 'app/classes';
import { NavService, SpinnerService, $Window } from 'app/services';
import { $Router } from '../router/router';
import { SETTINGS } from 'app/settings';

export class ApplicationEvents {

    constructor(public app: Application, public bus: MessageBus) {}

    /**
     * Register handlers for all of the commands that are sent from the app iframes.
     *
     */
    public registerAll() {

        this.on('appReady', this.app.readyResolve);

    // Respond to Data Requests

        this.on('getCurrentUser').respondWith($CurrentUser);
        this.on('getEnvironment').respondWith($Constants.env);
        this.on('getCurrentUrl').respondWith($Window.currentUrl);
        this.on('getBaseUrl').respondWith($Constants.buildUrl);
        this.on('getAppBaseUrl').respondWith(this.app.baseUrl);
        this.on('getUserPreferences').respondWith($CurrentUser.preferences);
        this.on('getPlatformDomain').respondWith($Constants.platformDomain);
        this.on('getAppIconPath').respondWith($Constants.appIcons);
        this.on('getEmailTempatePath').respondWith($Constants.emailTemplates);
        this.on('getCdnPath').respondWith($Constants.cdnAssets);
        this.on('getLocalizationOptions').respondWith( SETTINGS.LOCALIZATION_OPTIONS);

        this.on('getUserApps').respondWith(() => {
            return $CurrentUser.apps.map((app) => {
                return app.details();
            });
        });

    // Analytics from CP Home

        this.on('sendAnalyticsEvent', (event) => {
            $Analytics.sendEvent(event);
        });

    // Navigation

        this.on('navigationShow', NavService.show);
        this.on('navigationHide', NavService.hide);
        this.on('showErrorPage', $Router.showErrorPage);
        this.on('gotoRoute', $Router.goto);

    // Spinner Properties

        this.on('spinnerShow', SpinnerService.show);
        this.on('spinnerHide', SpinnerService.hide);

    // User Properties

        this.on('setUserPreferences', (prefs) => {
            $CurrentUser.setPreferences(prefs);
            $Router.broadcast('setUserPreferences', prefs);
        });

        this.on('setUserToken', (token) => {
            $CurrentUser.setToken(token);
            $CurrentUser.startSession().finally($Router.gotoSavedRoute);
        });

        this.on('refreshAvatar', (params) => {
            if ( typeof CustomEvent === 'function' ) {
                const refreshEvent = new CustomEvent('refreshAvatar', { 'detail': params.avatar_url});
                dispatchEvent(refreshEvent);
                return;
            } else {
                const event = 'refreshAvatar';
                const evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, false, false, {'detail': params.avatar_url});
            }
        });

        this.on('userLogout', $CurrentUser.destroySession);

    // Window Properties

        this.on('setPageTitle', (params) => {
            if (params.title) {
                $Window.setTitle(params.title, this.app.name);
            }
        });

    // Legacy Events

        /**
         * This legacy method is used to determine the environment.
         * To ensure backwards compatibility, we have to construct
         * the URL to look like the old one.
         *
         * @TODO: implement analytics to see who's using this.
         * @TODO: get rid of this once no-one uses it.
         */
        this.on('requestCurrentURL', () => {
            this.bus.send('currentURL', {url: $Window.currentUrl()}, {legacy: true});
        });

        /**
         * This legacy method is used to inform us of a route change
         * in the application so we can update our location to match
         * the deeplink.
         *
         * @TODO: implement analytics to see who's using this.
         * @TODO: get rid of this once no-one uses it.
         */
        this.on('appStateChange', (state) => {
            if (!this.app.showing) { return false; }
            const url = Url.build({
                pathname: Url.join(this.app.slug, state.path),
                search: state.search
            });
            $Router.deeplink(url);
        }).respondWith($Window.currentUrl);

    }

    /**
     * Private event register method, saves the destroy fns in an array
     * so all handlers can be removed at once via the destroy() method.
     *
     * @param {String} cmd
     * @param {Function} [callback]
     * @returns {IOnMessageEvent}
     */
    private on(cmd: string, callback?: (event: any) => void) {
        return this.bus.on(cmd, callback);
    }

}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/application/application.events.ts